<template>
  <v-icon
    v-if="dados.is_credit_card
      || dados.is_debit_card || dados.is_boleto || dados.is_boleto_in_installments"
    :data-cy="dataCyiconePagamento"
    class="pr-2"
    color="primary"
    small
  >
    {{ iconePagamento }}
  </v-icon>

  <v-img
    v-else-if="dados.is_pix"
    :src="require(`@/assets/img/logo-pix.png`)"
    alt="Logo Pix"
    class="flex-grow-0 mr-2"
    data-cy="icone_pix"
    height="17"
    width="48"
  />

  <v-img
    v-else-if="dados.is_paypal"
    :src="require(`@/assets/img/logo-paypal.png`)"
    alt="Logo Paypal"
    class="flex-grow-0 mr-2"
    data-cy="icone_paypal"
    height="20"
    width="64"
  />
</template>

<script>
export default {
  name: 'IconePagamento',

  props: {
    dados: {
      type: Object,
      required: true,
    },
  },

  computed: {
    dataCyiconePagamento() {
      return this.dados.is_boleto || this.dados.is_boleto_in_installments
        ? 'icone_boleto'
        : 'icone_cartao_credito';
    },

    iconePagamento() {
      return this.dados.is_boleto || this.dados.is_boleto_in_installments
        ? 'fas fa-barcode'
        : 'far fa-credit-card';
    },
  },
};
</script>
